// import chapter1 from './chapter1'

export default {
  state: {

    dashboardWidgets: {
      clock: true,
      decoder: false,
      notebook: true,
      amRadio: true,
      fmRadio: false
    },

    inGameDay: 2,
    inGameHours: 9,
    inGameMinutes: 41

    // playerLocationY: chapter1.state.playerLocationY + 1

  }
}
